import React from 'react';
import { LanguageOption } from '@src/types';
import { TranslateIcon } from '@features/ui/icons';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select';

type Props = {
  options: LanguageOption[];
  defaultLanguage: string;
  onChange: (value: string) => void;
  className?: string;
};

export const LanguageSwitch: React.FC<Props> = ({
  defaultLanguage,
  options,
  className,
  onChange,
}) => {
  return (
    <div className={className}>
      <Select defaultValue={defaultLanguage} onValueChange={onChange}>
        <SelectTrigger border={false} className="max-w-36 w-fit">
          <div className="flex gap-x-2 items-center">
            <TranslateIcon className="dark:text-white text-black" />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
